import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, MenuItem, Select } from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddAssistant({
  open,
  onClose,
  setOpen,
}: ModalProps) {
  return (
    <Modal
      className="modal rejectReason_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog take_action_modal">
        <div className="modal-body">

          {/* Header */}
          <div className="modal_title">
            <h2>Add Assistant</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>

          {/* Form */}
          <form className="form">
            <div className="gap_p">

              {/* Assistant Name */}
              <div className="control_group w_50">
                <label htmlFor="assistant-name">Assistant Name</label>
                <TextField
                  placeholder="Assistant Name"
                  fullWidth
                  hiddenLabel
                  inputProps={{ id: "assistant-name" }}
                />
              </div>

              {/* User Type */}
              <div className="control_group w_50">
                <label htmlFor="user-type">User Type</label>
                <Select fullWidth defaultValue="" displayEmpty inputProps={{ id: "user-type" }}>
                  <MenuItem value="" disabled>Select User Type</MenuItem>
                  <MenuItem value="Vendor">Vendor</MenuItem>
                  <MenuItem value="Customer">Customer</MenuItem>
                  <MenuItem value="Admin">Admin</MenuItem>
                </Select>
              </div>

              {/* Module */}
              <div className="control_group w_50">
                <label htmlFor="module">Module</label>
                <Select fullWidth defaultValue="" displayEmpty inputProps={{ id: "module" }}>
                  <MenuItem value="" disabled>Select Module</MenuItem>
                  <MenuItem value="Seasonal Opportunity Predictor">Seasonal Opportunity Predictor</MenuItem>
                  <MenuItem value="Auto-Optimization Engine">Auto-Optimization Engine</MenuItem>
                  <MenuItem value="Listing Quality Improvement">Listing Quality Improvement</MenuItem>
                  <MenuItem value="Conversion Funnel Diagnosis">Conversion Funnel Diagnosis</MenuItem>
                  <MenuItem value="Product Ranking Booster">Product Ranking Booster</MenuItem>
                </Select>
              </div>

              {/* Provider */}
              <div className="control_group w_50">
                <label htmlFor="provider-name">Provider Name</label>
                <Select fullWidth defaultValue="" displayEmpty inputProps={{ id: "provider-name" }}>
                  <MenuItem value="" disabled>Select Provider</MenuItem>
                  <MenuItem value="ChatGPT">ChatGPT</MenuItem>
                  <MenuItem value="Gemini">Gemini</MenuItem>
                  <MenuItem value="Claude">Claude</MenuItem>
                </Select>
              </div>

              {/* Model */}
              <div className="control_group w_50">
                <label htmlFor="model">Model</label>
                <Select fullWidth defaultValue="" displayEmpty inputProps={{ id: "model" }}>
                  <MenuItem value="" disabled>Select Model</MenuItem>
                  <MenuItem value="gpt-4">gpt-4</MenuItem>
                  <MenuItem value="gpt-4-turbo">gpt-4-turbo</MenuItem>
                  <MenuItem value="gemini-pro">gemini-pro</MenuItem>
                  <MenuItem value="claude-3-opus">claude-3-opus</MenuItem>
                  <MenuItem value="claude-3-sonnet">claude-3-sonnet</MenuItem>
                </Select>
              </div>

              {/* First Message */}
              <div className="control_group">
                <label htmlFor="first-message">First Message</label>
                <TextField
                  placeholder="Initial message shown to the user..."
                  fullWidth
                  multiline
                  rows={3}
                  hiddenLabel
                  inputProps={{ id: "first-message" }}
                />
              </div>

              {/* Action / System Prompt */}
              <div className="control_group ai_rec_btn">
                <label htmlFor="system-prompt">Action / System Prompt</label>
                <TextField
                  placeholder="Define assistant behavior, rules, and constraints..."
                  fullWidth
                  multiline
                  rows={4}
                  hiddenLabel
                  inputProps={{ id: "system-prompt" }}
                />
                <Button className="btn btn_primary sm">
                  <img src="/static/images/ai_icon.svg" alt="" /> Enhance with AI
                </Button>
              </div>

            </div>

            {/* Footer */}
            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                variant="outlined"
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>

              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Add
              </Button>
            </div>
          </form>

        </div>
      </div>
    </Modal>
  );
}